import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    height: 55,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3.7fr 8fr 6fr 8fr 0.5fr',
    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '4fr 8fr 6fr 8fr 1fr',
      height: 100
    },
    [theme.breakpoints.between(960, 1200)]: {
      gridTemplateColumns: '3.8fr 7fr 7.5fr 7.8fr'
    },
    textAlign: 'left',
    alignItems: 'center',
    paddingLeft: 12,
    backgroundColor: theme.palette.background.default,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    },
    borderRadius: 20,
    transition: 'background-color 0.3s ease-in-out',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '3fr 3fr'
    }
  },
  skeleton: {
    width: '80%'
  }
}))

export default useStyles
